import React, { Component } from "react";
import { Table, Input, Form, Button, Icon, Row, Col, Tooltip, message, Modal, AutoComplete, Select, Checkbox } from 'antd';
import getSize from "../../../utils/getSize";
import NHFetch from "../../../utils/NHFetch";
import NHTable from '../../common/NHTable';
import { NHConfirm } from '../../common/NHModal';
import NHContainerFrame from '../../common/NHContainerFrame';
import EditForm from './EditForm.js';
import ViewForm from './ViewForm.js';
import css from './index.css';
import AuditForm from './AuditForm';
import { getLoginUser, hasAuth } from '../../../utils/NHCore';
import { data } from "jquery";

const confirm = Modal.confirm;

const pathUrl = "/proData/selectDataList";
const baseUrlPath = "/swbl/lstd"; //基础路径
const basePath = "/swbl/zytz"; //基础路径
/**
 * 专业调整列表
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class Zytz extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            formInitData: {},
            showOperationBtn: false,
            frameVisibleMap: {
                tableFlag: true,
                addFlag: false,
                updateFlag: false,
                viewFlag: false,
                auditFlag: false,
            },
            selectedRowKeys: [],
            autoCompleteData: [],
            columnName: 'xh',
            shbjid: "",//审核页面的班级id
            statu: '',
            checked: true,
            dqnd: '',
            tableShowFlag: false,
        };
    }

    componentDidMount() {

        //获取帐号类型数据
        this.loadRemoteData(`DMK_YXXT_ZHLX`);

        //获取默认帐号类型
        NHFetch('/yxxc/getYxxtMrzhlx', 'GET')
            .then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        this.setState({ columnName: data });
                    }
                }
            });

    }
        
    componentWillMount() {
        this.getDqnd(); 
    }

     //获取当前年度
     getDqnd = () => {
        NHFetch('/newStudent/getDqnd', 'GET')
            .then(res => {
                if (res && res.data != null) {
                    this.setState({
                        dqnd: res.data,
                        tableShowFlag: true,
                    }, ()=> {
                        this.refs.nhTable.readTableData();
                    })                    
                }
            });
    }

    //设置当前页面显示
    setCurrentPageShow = (showFlagName) => {
        let frameVisibleMap = this.state.frameVisibleMap;
        for (let name in frameVisibleMap) {
            if (name == showFlagName) {
                frameVisibleMap[name] = true;
            } else {
                frameVisibleMap[name] = false;
            }
        }
        this.setState({
            frameVisibleMap: frameVisibleMap
        });
    }
    //关闭内嵌页面
    handleCloseFrame = () => {
        this.setCurrentPageShow('tableFlag');
    }
    //新增按钮点击事件
    handleAddBtnClick = () => {
        this.setState({ formInitData: {} });
        this.setCurrentPageShow('addFlag');
    }
    // //修改按钮点击事件
    // handleUpdateBtnClick = (record) => {
    //     this.setState({formInitData: record}, () => {
    //         this.setCurrentPageShow('updateFlag');
    //     });
    // }
    //审核按钮点击事件
    handleAuditBtnClick = (record) => {
        this.setState({ formInitData: record }, () => {
            this.setCurrentPageShow('auditFlag');
        })
    }
    //查看按钮点击事件
    handleViewBtnClick = (record) => {
        this.setState({ formInitData: record });
        this.setCurrentPageShow('viewFlag');

    }
    //单行删除
    handleSingleDeleteBtnClick = (record) => {
        NHConfirm("是否确定删除这条数据？", () => {
            let pkid = record.PKID;//TODO 把此处的信息改成自己的
            if (record.SHZT === '1' || record.SHZT === '-1') {
                message.warning("审核过的数据不能删除！");
                return;
            }
            this.handleDelete([pkid]);
        }, "warn");
    }
    //多行删除
    handleMultiDeleteBtnClick = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        let selectedRows = this.refs.nhTable.state.selectedRows;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            let isFlag = true;
            let array = [];//要删除的pkid集合
            for (let row of selectedRows) {
                if (row.SHZT == '1' || row.SHZT == '-1') {
                    isFlag = false;
                }
                array.push(row.PKID);
            }
            if (isFlag) {
                NHConfirm("是否确定删除选中的多条数据？", () => {
                    this.handleDelete(array);
                }, "warn");
            } else {
                message.warning("审核过的数据不能直接删除！您可以先撤销再删除");
            }
        } else {
            message.warning("请先选择需要删除的数据！");
        }
    }
    //删除操作
    handleDelete = (pkids) => {
        NHFetch(basePath + '/deleteByMulti', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("删除操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
    }
    //单行撤销
    handleBackoutBtnClick = (record) => {
        NHConfirm("是否确定撤销这条数据？", () => {
            let pkid = record.PKID;//TODO 把此处的信息改成自己的
            this.handleBackout([pkid]);
        }, "warn");
    }
    //撤销操作
    handleBackout = (pkids) => {
        NHFetch(basePath + '/cxzytz', 'POST', pkids)
            .then(res => {
                if (res) {
                    message.success("撤销操作成功！");
                    this.refs.nhTable.readTableData();
                }
            })
    }
    //新增面板保存方法
    handleSaveAdd = () => {
        this.refs.nhAddForm.validateFields((err, formData) => {
            const xsid = formData['xsid'];
            const nd = formData['nd'];
            const bj = formData['bj'];
            if (!xsid && !nd) {
                message.warning('未获取学生信息，请刷新重试。');
                return;
            }
            if (err) {
                return;
            }
            let params = formData;
            if (bj.length == 0) {
                delete formData['bj'];
                delete params['bj'];
                params['bj'] = '';
            }
            let yhbh = getLoginUser() ? getLoginUser().userId : '';
            params['yhbh'] = yhbh;
            NHFetch(basePath + '/insert', 'POST', params)
                .then(res => {
                    if (res) {
                        message.success("新增成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })

        })
    }
    //修改面板保存方法
    handleSaveUpdate = () => {
        this.refs.nhUpdateForm.validateFields((err, formData) => {
        })

    }
    //审核保存方法
    handleSaveAudit = () => {
        let yhbh = getLoginUser() ? getLoginUser().userId : '';
        this.refs.nhAuditForm.validateFields((err, formData) => {

            if (err) {
                return;
            }
            let data = formData;
            data['yhbh'] = yhbh;
            data['tzhbjid'] = this.state.shbjid;
            NHFetch(basePath + '/shzytz', 'POST', data)
                .then(res => {
                    if (res) {
                        message.success("审核成功！");
                        this.setCurrentPageShow('tableFlag');
                        this.refs.nhTable.readTableData();
                    }
                })
        });
    }
    handleSearch = () => {
        if (this.state.columnValue) {
            NHFetch(basePath + '/getYxxsByKey', 'get', {
                columnName: this.state.columnName,
                value: this.state.columnValue
            }).then(res => {
                if (res) {
                    let data = res.data;
                    if (data) {
                        if (data.length === 0) {
                            this.setState({ statu: '该学生不存在或该学生已添加！' }, () => {
                                this.setState({ autoCompleteData: data });
                            })
                        } else {
                            this.setState({ statu: '' }, () => {
                                this.setState({ autoCompleteData: data });
                            })
                        }
                    } else {
                        this.setState({ autoCompleteData: [] });
                    }
                }
            });
        } else {
            this.setState({ autoCompleteData: [] });
        }
    }
    handleChange = (value) => {
        NHFetch(baseUrlPath + '/getYxxsByUnion', 'get', { columnName: this.state.columnName, value: value }).then(res => {
            if (res) {
                this.setState({ formInitData: res.data }, () => {
                    this.refs.nhAddForm.resetFields(['xsid']);
                });
            }
        });
    }
    buildAutoComplete = (autoCompleteData) => autoCompleteData.map((item, key) => {
        if (key < 10) {  //限制显示10条，，数据过多页面卡顿
            return <AutoComplete.Option key={item.VALUE}>{item.TEXT}</AutoComplete.Option>
        }

    });

    getValue = (params) => { //获取审核页面的班级信息
        this.setState({
            shbjid: params
        });
    }

    //导出专业调整信息
    handleOutPcXx = () => {
        this.refs.nhTable.exportExcel('专业调整信息');
    }

    //加载远程数据
    loadRemoteData = (sign) => {
        NHFetch(pathUrl, 'GET', { sign: sign })
            .then(res => {
                if (res) {
                    console.log('res.data', res.data)
                    this.parseData(res.data);
                }
            });
    }

    //解析数据
    parseData = (data) => {
        if (data) {
            let nullOption = [{ value: '', label: '请选择...' }];
            this.setState({ data: [...nullOption, ...data] });
        }
    }
    // table选择后出现操作按钮
    rowSelectionChange = (selectedRowKeys) => {

        if (selectedRowKeys.length) {
            this.setState({
                showOperationBtn: true
            })
        } else {
            this.setState({
                showOperationBtn: false
            })
        }
    }

    //批量设置
    handleBatchSetCw = () => {
        let selectedRowKeys = this.refs.nhTable.state.selectedRowKeys;
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            NHConfirm("确定通过这些专业调整申请吗？", () => {
                this.handlePatchPass(selectedRowKeys);
            }, "warn");
        }
    }
    handlePatchPass = (pkids) => {
        let yhbh = getLoginUser() ? getLoginUser().userId : '';
        let data ={};
        for (let pkid of pkids) {
            data['pkid'] = pkid;
            data['shzt'] = '1';
            data['shyj'] = '批量审批通过';
            data['yhbh'] = yhbh;
            NHFetch(basePath + '/shzytz', 'POST', data).then(res => {
                if (res) {
                    message.info('调整成功。')
                    this.refs.nhTable.filterTableData();
                }
            });
        }

    }

    //勾选当前年度复选框
    onChange = (e) => {
        let { tableShowFlag } = this.state;
        if(e.target.checked) {
            tableShowFlag: true;
        }else {
            tableShowFlag: false;
        }
        this.setState({
          checked: e.target.checked,
          tableShowFlag: tableShowFlag,
        }, ()=>{
            this.refs.nhTable.readTableData();
        });
    };

    render() {
        let { data, showOperationBtn, tableShowFlag } = this.state;
        //列参数
        const columns = [
            {
                title: '序号',
                dataIndex: 'ROW_ID',
                width: '50px',
                // cacheFixed: 'left'
            }, {
                title: '学号',
                dataIndex: 'XH',
                width: '120px',
                searchType: "input",
                // cacheFixed: 'left'
            },
            {
                title: '考生号',
                dataIndex: 'KSH',
                width: '100px',
                searchType: "input",
                // cacheFixed: 'left'
            },
            {
                title: '身份证',
                dataIndex: 'SFZJH',
                width: '160px',
                searchType: "input",
                // cacheFixed: 'left'
            },

            {
                title: '姓名',
                dataIndex: 'XM',
                width: '80px',
                searchType: "input",
                // cacheFixed: 'left'
            }, {
                title: '性别',
                dataIndex: 'XB',
                width: '70px',
                searchType: "select"
            }, {
                title: '年度',
                dataIndex: 'ND',
                width: '100px',
                searchType: "select"
            },{
                title: '调整前学院',
                dataIndex: 'BMMC',
                width: '150px',
                searchType: "select"
            }, {
                title: '调整前专业',
                dataIndex: 'ZYMC',
                width: '120px',
                searchType: "select"
            }, {
                title: '调整前班级',
                dataIndex: 'BJMC',
                width: '150px',
                searchType: "select"
            }, {
                title: '调整后学院',
                dataIndex: 'YXH',
                width: '150px',
                searchType: "select"
            }, {
                title: '调整后专业',
                dataIndex: 'ZYH',
                width: '120px',
                searchType: "select"
            }, {
                title: '调整后班级',
                dataIndex: 'BJH',
                width: '150px',
                searchType: "select"
            }, {
                title: '申请时间',
                dataIndex: 'SQSJ',
                width: '150px',
                commonSearch: false,
                searchType: "datetime"
            }, {
                title: '操作人',
                dataIndex: 'SHR',
                width: '80px',
                searchType: "select",
                //hidden: true
            }, {
                title: '审核状态',
                dataIndex: 'SHZTMC',
                width: '100px',
                fixed: 'right',
                searchType: "select"
            }
            , {
                title: '审核意见',
                dataIndex: 'SHYJ',
                width: '80px',
                hidden: true
            }
        ];
        //行内操作
        const action = [
            // {
            //     title: '修改', onClick: this.handleUpdateBtnClick, auth: 'zhxg_yxgl_swbl_lstd:update'
            // },
            {
                title: '删除', onClick: this.handleSingleDeleteBtnClick, auth: 'zhxg_yxgl_swbl_zytz:delete'
            },
            {
                title: '审核', onClick: this.handleAuditBtnClick, isShow: (record) => {
                    if (record.SHZT == '0') {
                        return true;
                    }
                    return false;
                }
                , auth: 'zhxg_yxgl_swbl_zytz:review'
            },
            {
                title: '撤销', onClick: this.handleBackoutBtnClick, isShow: (record) => {
                    if (record.SHZT == '1' || record.SHZT == '-1' ||  record.SHZT == '3') {
                        return true;
                    }
                    return false;
                }
                , auth: 'zhxg_yxgl_swbl_zytz:review'
            },
            { title: '查看', onClick: this.handleViewBtnClick, auth: 'zhxg_yxgl_swbl_zytz:detail' }
        ];
        let autoCompleteData = this.state.autoCompleteData;
        return (
            <div className={css.main_right_content} style={{ height: getSize().windowH - 123 }}>
                {tableShowFlag ?  
                <div className={css.table} style={{ display: this.state.frameVisibleMap.tableFlag ? 'block' : 'none' }}>
                    <NHTable ref='nhTable'
                        rowKey={record => record.PKID}
                        sign={"zhxg_yxxt_swbl_zytz_queryPage"}
                        columns={columns}
                        action={action}
                        rowSelectionChange={this.rowSelectionChange}
                        initParams={this.state.checked ? {S_ND_EQ : this.state.dqnd} : {}}
                    >
                        {
                            hasAuth('zhxg_yxgl_swbl_zytz:add') ?
                                <Button type="primary" onClick={this.handleAddBtnClick}>新增</Button>
                                : null
                        }
                        {
                            hasAuth('zhxg_yxgl_swbl_zytz:delete') ?
                                <Button type="danger" ghost style={{ marginLeft: 10 }}
                                    onClick={this.handleMultiDeleteBtnClick}>删除</Button>
                                : null
                        }
                        {hasAuth('zhxg_yxgl_swbl_zytz:export') ? <Button type="primary" onClick={this.handleOutPcXx} style={{ marginLeft: 10 }}>导出</Button> : undefined}
                        {hasAuth('zhxg_yxgl_swbl_zytz:batchPass') && showOperationBtn && <Button type="primary" ghost style={{ marginLeft: 10 }} onClick={this.handleBatchSetCw}>批量通过</Button>}
                        <Checkbox checked={this.state.checked} onChange={this.onChange} style={{marginLeft:'10px',fontSize:'14px'}}>当前年度</Checkbox>
                    </NHTable>
                </div>
                : 
                null}
                <NHContainerFrame ref="nhAddModal"
                    title="新增专业调整"
                    visible={this.state.frameVisibleMap.addFlag}
                    onOk={this.handleSaveAdd}
                    onCancel={this.handleCloseFrame}
                >
                    <Row style={{ marginBottom: '24px', fontSize: '14px', lineHeight: '1.5' }}>
                        <Col span={4} style={{ textAlign: 'right' }}>
                            <Select defaultValue={this.state.columnName} style={{ width: '100px' }}
                                onChange={(value) => {
                                    this.setState({ columnName: value }, this.handleSearch);
                                }}>
                                {data && data.map(
                                    (item, index) => {
                                        return (
                                            <Select.Option key={index} value={item.VALUE}>{item.LABEL}</Select.Option>
                                        );
                                    }
                                )}
                            </Select>
                        </Col>
                        <Col span={20}>
                            <AutoComplete
                                style={{ marginLeft: '10px', width: '200px' }}
                                onSearch={(value) => {
                                    this.setState({ columnValue: value }, this.handleSearch);
                                }}
                                onSelect={this.handleChange}
                                placeholder={"请输入查询条件"}
                            >
                                {this.buildAutoComplete(autoCompleteData)}
                            </AutoComplete><span style={{ color: 'red' }}>{this.state.statu}</span>
                        </Col>
                    </Row>
                    <EditForm ref="nhAddForm" initFormData={this.state.formInitData} flag={false} />
                </NHContainerFrame>
                {/* <NHContainerFrame ref="nhUpdateModal"
                                  title="修改专业调整"
                                  visible={this.state.frameVisibleMap.updateFlag}
                                  onOk={this.handleSaveUpdate}
                                  onCancel={this.handleCloseFrame}
                >
                    <EditForm ref="nhUpdateForm" initFormData={this.state.formInitData}/>
                </NHContainerFrame> */}
                <NHContainerFrame ref="nhShowModal"
                    visible={this.state.frameVisibleMap.viewFlag}
                    title="查看专业调整" //TODO 把此处的信息改成自己的
                    onCancel={this.handleCloseFrame}
                    footer={[]}
                >
                    <ViewForm initFormData={this.state.formInitData} />
                </NHContainerFrame>
                <NHContainerFrame ref="nhAuditModal"
                    visible={this.state.frameVisibleMap.auditFlag}
                    title="审核专业调整" //TODO 把此处的信息改成自己的
                    onCancel={this.handleCloseFrame}
                    onOk={this.handleSaveAudit}
                >
                    <AuditForm ref="nhAuditForm" initFormData={this.state.formInitData} getValue={this.getValue} />
                </NHContainerFrame>
            </div>
        );
    }
}

export default Zytz;



// WEBPACK FOOTER //
// ./components/swbl/zytz/index.js